import { Button as MaterialButton, Collapse } from '@mui/material/';
import InputAdornment from '@mui/material/InputAdornment';
import SvgIcon from '@mui/material/SvgIcon';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/system';
import Image from 'next/image';
import { useState, useEffect } from 'react';
import BreadcrumbsComp from '../../components/Breadcrumbs/Breadcrumbs';
import Carousel from '../../components/Carousel/Carousel';
import Cooperate from '../../components/Cooperate/Cooperate';
import SearchIcon from '../../public/searchBlue.svg';
import styles from '../../styles/Onas.module.scss';
import { genericCalculatePercent } from '../../utils/calculateWidth';
import { useMobile } from '../../utils/useMobile';
import DarkArrow from '../../public/darkBlueArrow.svg';
import Arrow from '../../public/arrowDownBlue.svg';
import { content } from '../../utils/aboutUs';
import ReactHtmlParser from 'react-html-parser';
import Head from 'next/head';
import {
  MobileSelect,
  MobileSort,
  SelectField,
  SelectMenuItem,
} from '../../components/Select/Select';
import FormControl from '@mui/material/FormControl';

const SearchTextField = styled((props) => (
  <TextField {...props} sx={{ marginRight: '40px' }} />
))(() => ({
  '&': {
    marginRight: '24px',
    width: '344px',
  },
  '& .MuiOutlinedInput-root': {
    border: '1px solid #1d76bb',
    borderRadius: '32px',
    height: '40px',
  },
  '& .MuiInputBase-input': {
    padding: '8px !important',
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 400,
    fontSize: '14px',
    color: '#9caabf',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '@media (max-width:1365px)': {
    '&': {
      width: '264px',
    },
  },
}));

const PersonCard = styled((props) => <div {...props} />)((props) => ({
  '&': {
    backgroundImage: `url(${props.img}), url(/toyaCover.png), linear-gradient(90.05deg, #1C75BC 17.39%, #004D8A 98.79%) !important`,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    borderRadius: '8px !important',
  },
}));

const Onas = ({ data, meta }) => {
  const [open, setOpen] = useState(false);
  const [filteredPersons, setFilteredPersons] = useState(data);
  const [isVisible, setIsVisible] = useState(true);
  const [personToShow, setPersonToShow] = useState(data[0]);
  const [searchQuery, setSearchQuery] = useState('');
  const percent = genericCalculatePercent(18.5);
  const { isMobile, width } = useMobile();
  const [selectedTeam, setSelectedTeam] = useState('');
  const [selectedItem, setSelectedItem] = useState(1);
  const [teams, setTeams] = useState('');
  const options = [{ name: 'WSZYSCY', value: 'BRAK' }];

  useEffect(() => {
    setIsVisible(isMobile ? open : true);
  }, [open, isMobile]);

  const handleClick = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const filterPeople = (searchQuery) => {
    const filteredPeople = data.filter((person) => {
      return person.full_name.toLowerCase().includes(searchQuery.toLowerCase());
    });
    if (!selectedTeam) {
      setFilteredPersons(filteredPeople);
      setSelectedItem(0);
    } else {
      let filteredByTeam = filteredPeople;

      if (selectedTeam !== 'BRAK') {
        filteredByTeam = filteredPeople.filter((person) => {
          return person.team === selectedTeam;
        });
      }
      setFilteredPersons(filteredByTeam);
      setSelectedItem(0);
    }
  };

  const handleChange = (e) => {
    const text = e.target.value;
    setSearchQuery(text);
    filterPeople(text);
  };

  const typo = [{ url: '/', name: 'STRONA GŁÓWNA' }, { name: 'O NAS' }];

  useEffect(() => {
    const keys = Array.from(
      new Set(
        data.map((person) => {
          return person.team;
        })
      )
    );

    setTeams(keys);
  }, [data]);

  useEffect(() => {
    if (selectedTeam && selectedTeam !== 'WSZYSCY') {
      const filteredByTeam = data.filter((person) => {
        return person.team === selectedTeam;
      });
      setFilteredPersons(filteredByTeam);
      setSelectedItem(0);
    } else setFilteredPersons(data);
  }, [selectedTeam]);

  teams && teams.map((key) => options.push({ name: key, value: key }));

  return (
    <>
      <div className={styles.OnasContainer}>
        <div className={styles.OnasStory}>
          <div
            className={
              open
                ? `${styles.OnasHeader} ${styles.OnasHeaderOpen}`
                : styles.OnasHeader
            }
          >
            <div>
              <BreadcrumbsComp typo={typo} variant={'Onas'} />
              <div className={styles.OnasHeaderContainer}>
                <div className={styles.OnasH4}>
                  {ReactHtmlParser(content[0]?.title)}
                </div>
                {isVisible && (
                  <div className={styles.OnasTextHeader}>
                    <div>{ReactHtmlParser(content[0]?.text)}</div>
                  </div>
                )}
              </div>
              <div className={styles.OnasBottomOverlay} />
            </div>
          </div>

          <Collapse in={open}>
            <div className={styles.OnasCollapseContainer}>
              {content?.slice(1).map((el, idx) => (
                <div
                  className={styles.OnasContentContainer}
                  key={'aboutUs-' + idx}
                >
                  <div>
                    <div className={styles.OnasH4}>
                      {ReactHtmlParser(el.title)}
                    </div>
                    <div className={styles.OnasText}>
                      {ReactHtmlParser(el.text)}
                    </div>
                  </div>
                  <div className={styles.descPhotoContainer}>
                    <Image src={el.img} width='720px' height='464px' />
                  </div>
                </div>
              ))}
            </div>
          </Collapse>

          <div
            className={`${styles.buttonContainer} ${open ? styles.open : ''}`}
          >
            <MaterialButton
              sx={!open ? { width: '240px' } : { width: '120px' }}
              onClick={handleClick}
            >
              <span style={{ paddingRight: '13px' }}>
                {!open ? 'POZNAJ NASZĄ HISTORIĘ' : 'ZWIŃ'}
              </span>
              <DarkArrow
                style={
                  open
                    ? { transform: 'rotate(-90deg)' }
                    : { transform: 'rotate(90deg)' }
                }
              />
            </MaterialButton>
          </div>
        </div>

        <div className={styles.personContainer}>
          {personToShow ? (
            <div>
              <div className={styles.whiteBar}>
                <div>Nasz Zespół</div>
              </div>
              <div className={styles.personImageBig}>
                <img
                  src={personToShow.photo_file.replace('%%variant%%', '_b')}
                  className={styles.onasImg}
                />
              </div>
              <div className={styles.personTextContainer}>
                <div>{personToShow.name}</div>
                <div>{personToShow.surname}</div>
                <div>{personToShow.about}</div>
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
        <div className={styles.carouselContainer}>
          <div className={styles.searchContainer}>
            <SearchTextField
              placeholder='Wpisz wyszukiwaną osobę'
              variant='outlined'
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <SvgIcon
                      sx={{
                        cursor: 'pointer',
                        marginTop: '4px',
                        marginLeft: '4px',
                      }}
                      onClick={() => filterPeople()}
                    >
                      <SearchIcon />
                    </SvgIcon>
                  </InputAdornment>
                ),
              }}
              value={searchQuery}
              onChange={handleChange}
              size='small'
            />
            {width > 800 ? (
              <FormControl
                sx={{
                  width: '228px',
                  marginRight: '24px',
                  position: 'absolute',
                  right: '55px',
                  top: '23px',
                }}
              >
                <SelectField
                  value={selectedTeam}
                  onChange={(e) => {
                    setSelectedTeam(e.target.value);
                  }}
                  displayEmpty
                  size='small'
                  custVariant='dark'
                  sx={{ width: '250px' }}
                  IconComponent={Arrow}
                  renderValue={(selected) => {
                    if (!selected || selected.length === 0) {
                      return 'Dział, np. Prezenterzy';
                    }

                    return selected;
                  }}
                >
                  {options?.length &&
                    options.map((option) => {
                      return (
                        <SelectMenuItem value={option.name} key={option.value}>
                          {option.name}
                        </SelectMenuItem>
                      );
                    })}
                </SelectField>
              </FormControl>
            ) : (
              <MobileSort
                button={false}
                sx={{ display: 'inline-block' }}
                click={setSelectedTeam}
              >
                <MobileSelect
                  click={setSelectedTeam}
                  options={options}
                  defaultHeader={'Dział, np. Prezenterzy'}
                />
              </MobileSort>
            )}
          </div>
          <Carousel
            carouselVariant={
              filteredPersons?.length > 5 ? 'onas' : 'withPadding'
            }
            theme={'light'}
            selectedItem={isMobile ? 0.2 : 0}
            percent={percent}
            center={true}
            showIndicators={false}
            infiniteLoop={filteredPersons?.length > 5}
            arrows={filteredPersons?.length > 5 ? true : false}
          >
            {filteredPersons?.length ? (
              filteredPersons.map((person) => {
                const img = person.photo_file.replace('%%variant%%', '_web');
                return (
                  <PersonCard
                    img={img}
                    className={styles.personCard}
                    onClick={() => setPersonToShow(person)}
                  >
                    <div className={styles.personCardName}>
                      <span>{person.name + ` `}</span>
                      <span>{person.surname}</span>
                      <div>{person.duty}</div>
                    </div>
                  </PersonCard>
                );
              })
            ) : (
              <div style={{ height: '280px' }}></div>
            )}
          </Carousel>
        </div>
        <Cooperate />
      </div>
    </>
  );
};

export async function getServerSideProps() {
  let statusCode = 200;
  const response = await fetch(
    'https://webapi.toya.net.pl/v1/tvtoya/journalists',
    {
      method: 'GET',
      mode: 'cors',
      headers: { Authorization: 'Basic dHZ0b3lhOkFZVnVmVUFyR2Y3TWtFTnY=' },
    }
  );
  const data = await response.json();

  const metaRes = await fetch(
    'https://webapi.toya.net.pl/v1/tvtoya/metaTags?url=https://tvtoya.pl/onas',
    {
      method: 'POST',
      mode: 'cors',
      headers: { Authorization: 'Basic dHZ0b3lhOkFZVnVmVUFyR2Y3TWtFTnY=' },
    }
  );
  const metaData = await metaRes.json();
  if (metaData.meta.statusCode !== 200 || data.meta.statusCode !== 200)
    statusCode = 400;

  return { props: { data: data.data, meta: metaData, statusCode } };
}

export default Onas;
